"use client";

import { c as _c } from "react/compiler-runtime";
import { useClient } from "@repo/design-system/utils/client/client";
import type { ComponentType } from "react";
import { Suspense, useEffect, useRef } from "react";
import { TeaserBar as DefaultTeaserBar } from "../common/teaserbar-eon/teaserbar-eon";
import { useRegistry } from "../registry/registry-provider";
import { SearchSummary } from "./filterbar/search-summary-eon";
import { HeaderImageJobboard as DefaultHeaderImageJobboard } from "./headerimage/headerimage-jobboard-eon";
import JobBoardMap from "./map";
import { FilterbarSkeleton, JobListSkeleton } from "./skeletons-eon";
export default function JobBoard() {
  const $ = _c(23);
  const client = useClient();
  const filterbarAnchorRef = useRef(null);
  const {
    components
  } = useRegistry();
  const {
    Filterbar,
    Joblist
  } = components;
  const TeaserBar = (components as {
    TeaserBar?: ComponentType;
  }).TeaserBar ?? DefaultTeaserBar;
  const HeaderImageJobboard = (components as {
    HeaderImageJobboard?: ComponentType;
  }).HeaderImageJobboard ?? DefaultHeaderImageJobboard;
  const BoardMap = (components as {
    Map?: ComponentType;
  }).Map ?? JobBoardMap;
  let t0;
  let t1;
  if ($[0] !== client) {
    t0 = () => {
      if (client !== "eon") {
        return;
      }
      const timeoutId = window.setTimeout(() => {
        if (window.scrollY > 0) {
          return;
        }
        const filterbarAnchor = filterbarAnchorRef.current;
        if (!filterbarAnchor) {
          return;
        }
        const targetY = Math.max(filterbarAnchor.getBoundingClientRect().top + window.scrollY - 68, 0);
        window.scrollTo({
          top: targetY,
          behavior: "smooth"
        });
      }, 1500);
      return () => window.clearTimeout(timeoutId);
    };
    t1 = [client];
    $[0] = client;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== HeaderImageJobboard) {
    t2 = <Suspense><HeaderImageJobboard /></Suspense>;
    $[3] = HeaderImageJobboard;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FilterbarSkeleton />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== Filterbar) {
    t4 = <div ref={filterbarAnchorRef}><Suspense fallback={t3}><Filterbar /></Suspense></div>;
    $[6] = Filterbar;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== BoardMap) {
    t5 = <Suspense><BoardMap /></Suspense>;
    $[8] = BoardMap;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Suspense fallback={<div className="min-h-[80px] w-full bg-card" />}><SearchSummary /></Suspense>;
    t7 = <span id="job-results" />;
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <JobListSkeleton />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== Joblist) {
    t9 = <Suspense fallback={t8}><Joblist /></Suspense>;
    $[13] = Joblist;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== TeaserBar) {
    t10 = <Suspense><TeaserBar /></Suspense>;
    $[15] = TeaserBar;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t2 || $[19] !== t4 || $[20] !== t5 || $[21] !== t9) {
    t11 = <>{t2}{t4}{t5}{t6}{t7}{t9}{t10}</>;
    $[17] = t10;
    $[18] = t2;
    $[19] = t4;
    $[20] = t5;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}